__turbopack_context__.v({
  "active": "_0AQyua_active",
  "emoji": "_0AQyua_emoji",
  "emoji1": "_0AQyua_emoji1",
  "emoji2": "_0AQyua_emoji2",
  "emoji3": "_0AQyua_emoji3",
});
